import { Injectable, inject, LOCALE_ID } from '@angular/core';


const ICORTEX_ACCOUNTS_DEFAULT_ORIGIN = 'https://accounts.icortex.ai';

/** Account portal origins keyed by public site locale prefix or Angular LOCALE_ID. */
const ICORTEX_ACCOUNTS_ORIGIN_BY_LOCALE: Record<string, string> = {
  es: 'https://accounts-es.icortex.ai',
  pt: 'https://accounts-pt.icortex.ai',
  ko: 'https://accounts-ko.icortex.ai'
};


/**
 * @description Resolves the Auth / accounts portal base URL from the current path (e.g. /es/home) or the build LOCALE_ID.
 */
@Injectable( {
  providedIn: 'root'
} )
export class IcortexAccountsPortalUrlService {

  private readonly localeId = inject( LOCALE_ID );


  /**
   * @description Returns the accounts portal origin for the active language (English default).
   * @return Origin URL without trailing slash.
   */
  getAccountsPortalOrigin(): string {

    if ( typeof window === 'undefined' || !window.location ) {

      return this.resolveFromLocaleId();
    }

    const path = window.location.pathname || '';
    const firstSegment = path.split( '/' ).filter( ( s ) => s.length > 0 )[ 0 ]?.toLowerCase();

    if ( firstSegment && ICORTEX_ACCOUNTS_ORIGIN_BY_LOCALE[ firstSegment ] ) {

      return ICORTEX_ACCOUNTS_ORIGIN_BY_LOCALE[ firstSegment ];
    }

    return this.resolveFromLocaleId();
  }


  /**
   * @description Uses Angular LOCALE_ID when the URL has no /es/, /pt/ or /ko/ prefix (e.g. localized dev serve).
   * @return Origin URL without trailing slash.
   */
  private resolveFromLocaleId(): string {

    const mapped = ICORTEX_ACCOUNTS_ORIGIN_BY_LOCALE[ this.localeId ];

    if ( mapped ) {

      return mapped;
    }

    return ICORTEX_ACCOUNTS_DEFAULT_ORIGIN;
  }
}
